import { useChronicleTeams } from './useChronicleTeams'

export interface ChronicleTopStatsData {
  teamCount: number
  totalHectares: number
  groundCount: number
  lastTeamId: string | undefined
  isLoading: boolean
}

export function useChronicleTopStats(teamIds: string[]): ChronicleTopStatsData {
  const { teams, isLoading } = useChronicleTeams()

  const selected = teams.filter((t) => teamIds.includes(t.id))
  const totalHectares = selected.reduce((sum, t) => sum + t.hectares, 0)
  const groundCount = selected.reduce((sum, t) => sum + t.groundCount, 0)

  const storedLastTeamId =
    typeof window !== 'undefined'
      ? window.localStorage.getItem('wehunt:lastTeamId') ?? undefined
      : undefined
  const lastTeamId =
    storedLastTeamId && teamIds.includes(storedLastTeamId) ? storedLastTeamId : undefined

  return {
    teamCount: teamIds.length,
    totalHectares,
    groundCount,
    lastTeamId,
    isLoading,
  }
}
